var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _polygon, _path13, _path14, _path15, _path16, _path17, _path18, _polygon2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _g4, _path30, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.21 496.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8a895;\n      }\n\n      .cls-2 {\n        fill: #f7f8f8;\n      }\n\n      .cls-3 {\n        fill: #fadadd;\n      }\n\n      .cls-4 {\n        fill: #f9c6b8;\n      }\n\n      .cls-5 {\n        fill: #f9ca8e;\n      }\n\n      .cls-6 {\n        fill: #010101;\n      }\n\n      .cls-7 {\n        fill: #eca36a;\n      }\n\n      .cls-8 {\n        fill: #ec6431;\n      }\n\n      .cls-9 {\n        fill: #e58e7d;\n      }\n\n      .cls-10 {\n        fill: #ea8a72;\n      }\n\n      .cls-11 {\n        fill: #f48586;\n      }\n\n      .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-13 {\n        fill: #f15941;\n      }\n\n      .cls-14 {\n        fill: #ef4823;\n      }\n\n      .cls-15 {\n        fill: #e69885;\n      }\n\n      .cls-16 {\n        fill: #df6a73;\n      }\n\n      .cls-17 {\n        fill: #dc3e26;\n      }\n\n      .cls-18 {\n        fill: #de776c;\n      }\n\n      .cls-19 {\n        fill: #e04526;\n      }\n\n      .cls-20 {\n        fill: #25100b;\n      }\n\n      .cls-21 {\n        fill: #404040;\n      }\n\n      .cls-22 {\n        fill: #3e1313;\n      }\n\n      .cls-23 {\n        fill: #457e3b;\n      }\n\n      .cls-24 {\n        fill: #2b140e;\n      }\n\n      .cls-25 {\n        fill: #351212;\n      }\n\n      .cls-26 {\n        fill: #584b47;\n      }\n\n      .cls-27 {\n        fill: #766464;\n      }\n\n      .cls-28 {\n        fill: #525252;\n      }\n\n      .cls-29 {\n        fill: #505f84;\n      }\n\n      .cls-30 {\n        fill: #835252;\n      }\n\n      .cls-31 {\n        fill: #78c9b1;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m395.52,124.95s-10.21,7.35-15.52,26.14c-5.31,18.79-9.39,50.23-9.39,50.23l20.01,3.68s19.19-35.12,22.46-54.73c3.27-19.6-11.03-27.36-17.56-25.32Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m324.32,165.65s63.17,17.97,66.43,30.49c3.27,12.52-11.98,20.15-24.5,13.61-12.52-6.53-46.29-36.48-46.29-36.48l4.36-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m323.28,174.27s-13.75.65-15.28.22c-1.53-.44-10.91-10.69-10.91-10.69,0,0-1.75-11.79-.87-13.97.87-2.18,1.75-2.84,3.06-3.06,1.31-.22.44,3.49.44,3.49,0,0,6.77,5.46,9.17,6.55,2.4,1.09,8.08,1.96,8.08,1.96,0,0-.87-3.06-.87-4.15s-3.71-3.27-2.4-6.33c1.96-.22,4.36,2.62,6.33,3.49,1.96.87,6.77,16.8,6.77,16.8l-3.49,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m316.95,158.78s-5.67-.87-8.08-1.96c-2.4-1.09-9.17-6.55-9.17-6.55l.24,5.72,3.54,7.35,8.03-2.86s.54,1.5-.54,2.86-4.22,2.31-4.22,2.31c0,0,4.08.14,6.81,1.09,2.72.95,3.13,3.95,3.13,3.95l4.22-1.63s.82-1.5-1.23-3.95c-2.04-2.45-2.74-6.33-2.74-6.33Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.79,197.78s-4.9,9.53.82,13.07,13.89-.82,16.61-6.26-17.42-6.81-17.42-6.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m410.5,470.01s2.72,22.05,2.72,24.23h-40.84s-10.07,0,4.08-8.44c6.51-3.88,15.52-3.81,18.24-9.26,2.72-5.45,3.27-8.44,3.27-8.44l12.52,1.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m386.95,244.06s1.63,172.62,8.17,225.98l17.15.82s17.15-188.14,17.7-212.64c.54-24.5,0-26.14,0-26.14l-43.02,11.98Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m465.94,494.55h30.18c-.14-9.54-5.3-28.59-5.3-28.59l-11.84,2.86s1.23,6.94-4.49,13.48c-4.27,4.88-7.62,9.75-8.54,12.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m469.71,241.34l23.41,228.7h-16.88s-28.32-106.18-32.67-122.52c-4.36-16.34-35.94-105.09-35.94-105.09l62.08-1.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m386.95,245.43s.82,20.42,33.9,18.38l8.58-23.69-42.47,5.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m415.81,110.11s-16.88,8.17-22.87,18.51c-5.99,10.35-20.69,65.34-7.08,118.98,7.62,4.36,63.98,8.17,86.85-5.45,3.27-5.99,7.35-59.08,13.34-86.31,5.99-27.23,4.9-43.02-5.45-45.74-10.35-2.72-30.49-7.08-30.49-7.08l-34.31,7.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m435.95,78.8l-18.79,29.4s-.82,13.48,16.34,7.35c13.07-5.72,19.19-11.03,19.19-11.03l-9.39-37.57-7.35,11.84Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m455.83,104.39l-3.27-6.26s-16.61,13.34-26.14,13.34l-3.54,3.54-1.63-3.81s-2.38-.34-4.02-4.15c0,0-5.79,8.24-4.42,15.04,1.09,0,5.17-5.72,5.17-5.72l4.63,3.81,3.27-1.36,6.26,9.53s12.52-8.78,23.69-23.96Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m423.69,117.32l-1.61-.27c-.14.83-11.64,71.38-7.09,134.49.55.02,1.09.03,1.64.04-4.57-62.93,6.93-133.43,7.07-134.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m478.97,110.65s14.7,1.09,17.97,34.85c3.27,33.76,3.27,60.99,3.27,60.99l-25.59,2.18s-16.88-63.17-16.88-76.23,14.16-22.87,21.24-21.78Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m412.02,54.12s-4.21,26,1.15,39.76c4.21,6.12,22.94.76,32.12-9.18,9.18-9.94,11.85-26.76,7.65-37.09-4.21-10.32-23.71-10.71-29.82-8.41s-10.71,10.71-11.09,14.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m412.79,51.1s17.2-6.14,31.67,7.34c1.97,7.56-.99,23.67-.99,23.67,0,0,14.47-3.62,17.42-21.7,1.31-18.08-8.11-18.3-8.11-18.3,0,0-2.19-8.77-14.03-12.71-11.84-3.95-33.75-2.63-26.19,21.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m444.61,74.68s6.17-6.73,8.69-1.68c2.52,5.04-10.37,12.33-10.65,8.69-.28-3.64,1.96-7.01,1.96-7.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 427.28,
    cy: 68.77,
    r: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m416.43,68.47c0,1.04-.85,1.89-1.89,1.89s-1.89-.85-1.89-1.89.85-1.89,1.89-1.89,1.89.85,1.89,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m418.82,71.93s-3.95,8.22-3.45,8.88c.49.66,3.45,0,5.1-1.15,1.64-1.15-2.14-1.81-2.14-1.81,0,0,2.63-6.57.49-5.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m417.61,85.4l8.44-.55s-.22,3.94-4.38,3.94-4.05-3.4-4.05-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m420.9,86.39c1.51-.12,2.39-.78,2.9-1.39l-5.5.36c.23.52.86,1.16,2.6,1.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m425.77,64.25s2.74-.88,5.04.6c.49-.11.11-1.48-1.21-1.81s-4.27-.16-3.84,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m412.73,64.04s2.74-.88,5.04.6c.49-.11.11-1.48-1.21-1.81-1.31-.33-4.27-.16-3.84,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m433.45,76.24c0,1.29-1.12,2.34-2.51,2.34s-2.51-1.05-2.51-2.34,1.12-2.34,2.51-2.34,2.51,1.05,2.51,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m410.47,73.9s-.01,0-.02,0c0,1.54.01,3.11.08,4.68,1.36-.03,2.45-1.06,2.45-2.34s-1.12-2.34-2.51-2.34Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "418.55 135.85 424.62 203.1 371.03 204.61 366.48 137.37 418.55 135.85"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m433.23,175.45s63.17,17.97,66.43,30.49c3.27,12.52-11.98,20.15-24.5,13.61-12.52-6.53-46.29-36.48-46.29-36.48l4.36-7.62Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.22,160.61s-11.71-1.09-12.8-.82c-1.09.27-4.9,8.44-4.9,8.44l1.36,5.72s2.99,4.36,4.63,4.36-.27-3.81-.27-3.81c0,0,3.54,4.63,6.53,6.26,2.99,1.63,13.34,3.54,13.34,3.54l3.81-7.62-5.72-17.97-12.05-7.9-9.26.41s.68,2.18,2.99,2.72c2.31.54,5.58.82,5.58.82l6.74,5.85Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m315.38,230.12s2.66,3.33,4.28,5.18c1.61,1.85,6.5,3.61,6.5,3.61,0,0,6.18.39,6.52,1.41s-.63,1.6-1.52,2.03c-.88.43-4.54-.13-4.54-.13l-4.41-1.25s3.34,1.97,4.43,2.47c1.08.5,3.36-.23,3.79.04.42.28,3.13-.18,2.95.71-.17.89-1.32,2.96-2.93,4.53-1.62,1.56-4.55,2.68-5.39,2.74-.84.06-3.57-1.31-3.99-1.58-.42-.28-3.02-2.16-3.02-2.16l-3.72-5.42s-2.67-7.35,1.05-12.17Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.23,230.28s5.04-.95,5.45-1.29c.42-.33,3.85-1.92,5.34-2.97,1.48-1.05,6.91-7.57,6.91-7.57,0,0,1.47,1.76,1.04,4.29-.43,2.53-3.71,6.03-3.71,6.03,0,0-1.92,2.97-1.71,5.12.22,2.15.28,7.01.16,8.74-.12,1.73,1.89,4.84,1.89,4.84,0,0,5.05,3.67,4.83,4.94-.22,1.26-.5,1.08-1.67.72-1.17-.36-5.47-3.95-5.47-3.95,0,0-4.85-6.15-6.49-6.41-1.64-.26-9.43-5.91-9.43-5.91l2.86-6.58Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m208.11,122.19s14.31-3.55,27.93,27.52c13.62,31.06,22.11,56.93,22.11,56.93l-23.64,10.04s-35.72-54.76-39.8-67.18c-4.07-12.42,6.33-26.14,13.39-27.31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m238.24,470.51s-2.72,22.05-2.72,24.23h40.84s10.07,0-4.08-8.44c-6.51-3.88-15.52-3.81-18.24-9.26-2.72-5.45-3.27-8.44-3.27-8.44l-12.52,1.91Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "220.03 240.85 253.73 472.07 235.53 472.07 174.86 243.54 220.03 240.85"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m179.45,494.38h-30.18c.14-9.54,5.3-28.59,5.3-28.59l11.84,2.86s-1.23,6.94,4.49,13.48c4.27,4.88,7.62,9.75,8.54,12.25Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m159.89,232.18l-16.72-4.81s1.35,198.19,8.09,242.01h18.88s6.42-114.3,12.45-183.59c4.25-4.08,20.93-22.06,23.28-54.37,1.85-25.45-27.43-10.87-45.98.77Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m203.01,96.59l1.85,19.55s9.65,16.16-7.5,10.04c-13.07-5.72-19.19-11.03-19.19-11.03l9.39-37.57,15.45,19.01Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m218.84,64.74s4.21,26-1.15,39.76c-4.21,6.12-22.94.76-32.12-9.18-9.18-9.94-11.85-26.76-7.65-37.09,4.21-10.32,23.71-10.71,29.82-8.41,6.12,2.29,10.71,10.71,11.09,14.91Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m140.99,244.55s4.55,6.07,37.41,4.55c32.86-1.52,42.64-6.57,42.64-6.57-1.52-15.67,11.8-45.17,7.42-105.16-.43-5.88-18.54-17.53-18.54-17.53,0,0,1.85-7.58-2.86-8.26-3.67,0-19.08-3.16-25.74-4.57-1.9-.4-3.85.3-5.06,1.82l-3.41,4.27s-20.22,8.09-25.78,18.2c0,0-6.57,7.58-5.56,33.37,1.01,25.78,10.24,42.6,10.24,44.11s-10.74,35.77-10.74,35.77Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m207.22,46.53s9.94.84,13.65,9.1-11.97,12.64-20.39,12.81-16.85-2.53-16.85-2.53c0,0,3.37,3.54,3.37,7.58s-3.71,5.39-3.71,7.75.67,6.57.67,6.57l-2.7-.67s-5.22-3.54-6.4-12.64-.51-18.37,7.08-23.93c7.58-5.56,25.28-4.04,25.28-4.04Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.62,85.3s-6.17-6.73-8.69-1.68c-2.52,5.04,10.37,12.33,10.65,8.69s-1.96-7.01-1.96-7.01Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m165.65,119.49s-14.31-3.55-27.93,27.52c-13.62,31.06-22.11,56.93-22.11,56.93l23.64,10.04s35.72-54.76,39.8-67.18c4.07-12.42-6.33-26.14-13.39-27.31Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m164.27,259.99s-21.55-62.04-34.24-64.58c-12.69-2.55-19.43,13.11-12.19,25.24,7.24,12.13,39.07,44.13,39.07,44.13l7.36-4.78Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m304.42,229.75s-53.43-38.19-65.26-32.94c-11.83,5.25-8.29,21.93,4.63,27.65,12.92,5.72,57.38,13.45,57.38,13.45l3.25-8.16Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m216.32,94.56c-3.2-2.19-7.75-2.02-12.81-.67-5.06,1.35-9.27,1.01-15.5-4.89-6.24-5.9-4.38-9.44-4.38-9.44,0,0-4.55-1.35-2.02,2.36,2.53,3.71,1.85,10.62,1.85,10.62,0,0-.01.06-.03.15.67.92,1.38,1.81,2.14,2.64,9.18,9.94,27.91,15.29,32.12,9.18.94-2.41,1.57-5.19,2-8.14-.96-.38-2.13-.95-3.37-1.8Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 203.58,
    cy: 79.39,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 216.32,
    cy: 79.09,
    r: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m212.04,82.54s3.94,8.22,3.45,8.88c-.49.66-3.45,0-5.1-1.15s2.14-1.81,2.14-1.81c0,0-2.63-6.58-.49-5.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m213.25,96.02l-8.44-.55s.22,3.94,4.38,3.94,4.05-3.4,4.05-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m209.96,97.01c-1.51-.12-2.39-.78-2.9-1.39l5.5.36c-.23.52-.86,1.16-2.6,1.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m205.08,74.87s-2.74-.88-5.04.6c-.49-.11-.11-1.48,1.21-1.81s4.27-.16,3.84,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m218.12,74.65s-2.74-.88-5.04.6c-.49-.11-.11-1.48,1.21-1.81,1.31-.33,4.27-.16,3.84,1.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 199.92,
    cy: 86.86,
    rx: 2.51,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m220.38,84.52s.01,0,.02,0c0,1.54-.01,3.11-.08,4.68-1.36-.03-2.45-1.06-2.45-2.34s1.12-2.34,2.51-2.34Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.65,226.97s-5.31,14.7-13.89,14.7-15.93-16.74-15.93-16.74l29.81,2.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "135.23 173.88 134.41 163.67 113.99 166.94 114.81 173.47 135.23 173.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "144.62 228.6 148.7 170.61 131.55 173.06 144.62 228.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m82.13,127.46s11.98,2.18,20.69,18.51c8.71,16.34,14.16,59.9,11.44,68.07-4.9,8.17-21.78-1.09-29.95-25.59-8.17-24.5-22.87-61.53-2.18-60.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "89.76 173.2 142.17 168.57 144.62 228.6 63.62 232.01 64.71 175.38 89.76 173.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m60.49,46.05s-20.01,0-26.95,19.19c-6.94,19.19,9.39,32.67,6.13,42.07-3.27,9.39-17.97,8.98-15.93,29.81,2.04,20.83,39.21,35.12,57.18,22.46,17.97-12.66,15.93-22.87,8.17-34.71s-11.84-8.17-11.03-22.87c.82-14.7,17.97-22.05,12.66-39.21-5.31-17.15-30.22-16.74-30.22-16.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.62,460.17s-.27,5.99,1.09,8.98c1.36,2.99,7.96,14.97,11.23,16.61,3.27,1.63,5.31,4.9,6.13,4.9s-.48-.27-4.83-.82c-4.36-.54-6.26,1.36-11.71-1.63-5.45-2.99-5.72-6.81-7.62-8.71-1.91-1.91-7.08-3.27-8.71-4.63-1.63-1.36,1.36-7.62,1.36-7.62l-1.09-10.35,14.16,3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m112.14,496.65c-1.77-1.46-4.41-4.9-4.41-4.9v4.9h-5.47c-.14-3.89-.66-20.55.3-21.51,1.09-1.09,3.83.77,6.26,1.63,4.63,1.63,10.62,10.62,10.62,10.62.68-8.17,6.4-8.78,6.4-8.78,12.64,11.03,13.75,9.6,18.92,13.68,3.13,2.47,3.66,3.73,3.6,4.36h-36.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m90.85,227.92l30.22,233.6h-16.34s-35.12-80.86-47.37-149.47c-12.25-68.61,14.7-82.5,33.49-84.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m93.16,211.45s7.76,26.95-7.35,52.28c-4.9,3.27.41,1.23.41,1.23l-26.95-46.97,35.12-6.94"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.18,454.99s2.72,15.25,3.27,17.7c.54,2.45,10.89,19.33,10.89,19.33h-24.5s-1.36-10.07-1.63-22.33c-.27-12.25-.54-21.51-.54-21.51l12.52,6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m58.17,463.57h-16.34s-26.55-109.86-25.73-164.58c.82-54.73,7.21-58.54,23.55-82.22l42.88,6.13c5.63,15.47-6.94,35.53-21.92,71.2l-2.45,169.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.2,221.61s-.95,2.18.95-6.39c1.91-8.57,6.19-31.91,7.62-47.15,1.43-15.24-14.29-36.2-14.29-36.2,0,0-8.57-8.57-15.24-10.48-6.67-1.9-25.72-1.9-25.72-1.9,0,0-27.15-.48-32.86,17.15-6.51,10.48,7.73,38.89,9.53,42.39,20.33,39.5,10.39,42.09,10.94,42.77,0,0,22.12,10.28,39.27,8.85,17.15-1.43,19.8-9.04,19.8-9.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m72.17,97.74s-4.52,17.62,4.05,25.72c-1.43,3.33-6.67,8.33-15.72,5.95-9.05-2.38-11.91-6.43-12.86-8.57.24-3.57,4.05-15.48,2.86-27.62l21.67,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.41,69.14s1.92,11.88,1.28,23.17c-.56,9.85-10.67,16.06-19.71,12.1-4.24-1.86-8.4-4.57-11.41-7.83-8.23-8.92-10.63-24.01-6.86-33.27,3.77-9.26,21.27-9.6,26.75-7.55s9.6,9.6,9.95,13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.75,86.91s-6.5-7.1-9.16-1.77c-2.66,5.32,10.94,13.01,11.23,9.16.3-3.84-2.07-7.39-2.07-7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m48.64,114.73s10.99,9.37,17.82,9.84c.95.32,2.54,5.22,3.01,4.59.48-.64.48-4.74.48-4.74,0,0,2.7-1.27,3.97-4.29,2.38.79,5.87,10,6.03,15.56-1.91-2.54-3.81-6.19-4.92-6.51-1.11-.32-2.52,1.94-4.74,2.74-2.22.79-8.17-1.63-8.17-1.63,0,0-3.44,6.99-3.76,8.9-1.91-.48-11.07-12.62-12.34-18.02-.24-6.19,2.62-6.43,2.62-6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m46.24,496.65c-.42-1-.59-1.91-.59-1.91l-.25,1.91h-3.7l1.5-25.32,1.91,16.88s4.63-4.36,11.98-6.26c7.35-1.91,11.98,6.53,11.98,6.53,2.57,3.21,3.71,6.23,4.22,8.17h-27.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.01,277.41l-.61,11.84-4.7,13.48s-2.04,1.23-2.25-2.25c-.2-3.47,1.02-6.74,1.02-6.74v-1.43l-3.88,7.96s-6.13,4.9-7.15,4.7c-1.02-.2,0-3.27,0-3.27,0,0,0-10.41.41-12.46,0,0,6.94-4.7,7.56-5.31.61-.61,1.23-8.17,1.23-8.17l8.37,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m25.5,124.73s-13.61,3.81-17.43,27.23c-3.81,23.41,0,129.6,0,129.6h10.89s12.52-49.01,9.8-68.61c0,0,13.61-50.64,9.8-69.7-3.81-19.06-13.07-18.51-13.07-18.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.87,229.56s-8.17-17.7-9.26-17.7c-1.63.54-1.63,2.18-1.36,3.27.27,1.09.82,4.63.82,4.63,0,0-4.63,2.45-5.45,3.81s-2.18,3.81-2.18,3.81l-2.45,1.91,1.63,2.45s7.62,2.45,12.25,2.18c4.63-.27,5.99-4.36,5.99-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.06,230.85s2.65-3.06,2.65-5.31-.2-6.53-.2-6.53c0,0-3.68-4.29-4.29-6.33-1.63.82-2.04,2.65-1.63,4.49.41,1.84.61,3.47.61,3.47l-1.23,4.29,4.08,5.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 68.34,
    cy: 81.63,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 81.08,
    cy: 81.33,
    r: 1.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.29,94.86l-8.44-.55s.22,3.95,4.38,3.95,4.05-3.4,4.05-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m75,95.84c-1.51-.12-2.39-.78-2.9-1.39l5.5.36c-.23.52-.86,1.16-2.6,1.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m69.85,77.11s-2.74-.88-5.04.6c-.49-.11-.11-1.48,1.21-1.81s4.27-.16,3.84,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m82.89,76.89s-2.74-.88-5.04.6c-.49-.11-.11-1.48,1.21-1.81,1.31-.33,4.27-.16,3.84,1.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 64.69,
    cy: 89.1,
    rx: 2.51,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 83.47,
    cy: 89.1,
    rx: 2.51,
    ry: 2.34
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m75.46,87.3s1.77,4.08,1.5,4.63c-.27.54-2.18-.27-2.18-.27,0,0-.68-4.08.68-4.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m82.41,50.41s12.25,7.9,8.17,22.87c-5.1-13.95-8.98-14.43-8.98-14.43,0,0-7.08-1.09-11.98,11.71-4.9,12.8-7.35,17.97-15.52,19.88s-13.61,2.72-13.61,2.72c0,0-6.81-20.15-.54-32.4,6.26-12.25,28.32-21.78,42.47-10.35Z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m49.73,94.29c0,.99.8,1.79,1.79,1.79s1.79-.8,1.79-1.79-.8-1.79-1.79-1.79-1.79.8-1.79,1.79Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 241.03,
    width: 99.05,
    height: 70.44,
    rx: 10.27,
    ry: 10.27,
    transform: "translate(581.11 70.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "241.03 60.17 241.03 92.1 259.19 70.44"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 255.6,
    y: 22.09,
    width: 69.92,
    height: 5.02,
    rx: 2.15,
    ry: 2.15,
    transform: "translate(581.11 49.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 255.6,
    y: 32.71,
    width: 69.92,
    height: 5.02,
    rx: 2.15,
    ry: 2.15,
    transform: "translate(581.11 70.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 255.6,
    y: 43.33,
    width: 69.92,
    height: 5.02,
    rx: 2.15,
    ry: 2.15,
    transform: "translate(581.11 91.67) rotate(180)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m434.2,136.97v6.51c0,.12.06.23.15.26l2.19.66c.09.03.15.13.15.26v2.38c0,.06-.01.11-.04.15l-1.27,2.34c-.06.11-.05.25.02.34l.65.86c.06.08.16.1.24.04l4.62-3.58c.06-.05.1-.13.1-.23v-10c0-.15-.09-.26-.2-.26h-6.43c-.11,0-.2.12-.2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m438.1,136.24h-.13s-.05-.01-.06-.03l-2.34-2.84c-.04-.05,0-.13.06-.13h1.3s.06.02.07.05l1.17,2.84c.02.05-.02.11-.07.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m444.22,136.97v6.51c0,.12.06.23.15.26l2.19.66c.09.03.15.13.15.26v2.38c0,.06-.01.11-.04.15l-1.27,2.34c-.06.11-.05.25.02.34l.65.86c.06.08.16.1.24.04l4.62-3.58c.06-.05.1-.13.1-.23v-10c0-.15-.09-.26-.2-.26h-6.43c-.11,0-.2.12-.2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m448.13,136.24h-.13s-.05-.01-.06-.03l-2.34-2.84c-.04-.05,0-.13.06-.13h1.3s.06.02.07.05l1.17,2.84c.02.05-.02.11-.07.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/Onboarding.cfaa3a8c60b19b291b13f4d7f0540a77.svg";
export { ForwardRef as ReactComponent };